import { render, staticRenderFns } from "./ManifestationSection.vue?vue&type=template&id=28d0b612&"
import script from "./ManifestationSection.vue?vue&type=script&lang=js&"
export * from "./ManifestationSection.vue?vue&type=script&lang=js&"
import style0 from "./ManifestationSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VIcon,VSpacer})
